import { Device } from '@livecontrol/core-ui';
import type { ReactElement } from 'react';
import styled from 'styled-components';
//Added this exception to avoid a circular logic
/* eslint-disable-next-line import/no-internal-modules */
import { RAIL_COLLAPSED, RAIL_EXPANDED, useLayout } from '../layout/context';
import { Brand } from './brand';
import { NavTabs } from './nav-tabs';
import { User } from './user';

const EDGE = 30;

const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  padding: 22px ${EDGE}px 16px;
  background: #080e1e;
  border-bottom: 1px solid var(--white10);
  transition: padding-left var(--transition);
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const Hamburger = styled.button`
  color: var(--white60);
  font-size: 18px;
  background: transparent;
  border: none;
  padding: 0;
  margin-right: 4px;
`;

export const Header = (): ReactElement => {
  const { viewport, sidebar, pinned, setPinned } = useLayout();

  const isMobile = Device.isMobile(viewport);

  /*
   * Track the pinned rail; hovering the sidebar overlays the content, so the
   * header keeps the collapsed offset until the rail is pinned open.
   */
  const paddingLeft = isMobile || !sidebar ? EDGE : (pinned ? RAIL_EXPANDED : RAIL_COLLAPSED) + EDGE;

  return (
    <Container style={{ paddingLeft }}>
      <div className='d-flex align-items-center'>
        {isMobile && sidebar && (
          <Hamburger
            type='button'
            onClick={(): void => {
              setPinned(!pinned);
            }}
          >
            <i className='fas fa-bars' />
          </Hamburger>
        )}
        <Brand />
      </div>

      <Options>
        <NavTabs />
        <User viewport={viewport} />
      </Options>
    </Container>
  );
};
